import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatDividerModule } from '@angular/material/divider'
import { RouterOutlet } from '@angular/router'

import { TranslateModule } from '@ngx-translate/core'

import { PerformanceFacade, SUMMARY_FLAGS_VALUES } from '~/core/features'
import { EPerformanceSummaryFlag } from '~/core/models'
import { MetaTagService } from '~/core/services'
import { LoadingComponent } from '~/ui/loading'

import { PerformanceRateContainerComponent } from './lazy-components/performance-rate-container/performance-rate-container.component'
import {
  PerformanceNavigationComponent,
  PerformancePeriodComponent,
  PerformanceSummaryFlagSelectorComponent,
  PerformanceTotalComponent,
} from './components'

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrl: './performance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    RouterOutlet,
    MatCardModule,
    TranslateModule,
    MatDividerModule,
    LoadingComponent,
    PerformanceTotalComponent,
    PerformancePeriodComponent,
    PerformanceNavigationComponent,
    PerformanceRateContainerComponent,
    PerformanceSummaryFlagSelectorComponent,
  ],
})
export class PerformanceComponent implements OnDestroy {
  private readonly metaTagService = inject(MetaTagService)

  readonly performanceFacade = inject(PerformanceFacade)

  EPerformanceSummaryFlag = EPerformanceSummaryFlag
  SUMMARY_FLAGS_VALUES = SUMMARY_FLAGS_VALUES

  constructor() {}

  ngOnDestroy(): void {
    this.metaTagService.setHomePageMeta()
  }
}
